import { Relations, UserId } from "@inrev/common";
import { ActionItem } from "@portal/api/action-item/admin";
import { useActionItemsSelectionDispatch } from "@portal/providers/ActionItemsSelectionProvider";
import { CreateOrUpdateActionItem } from "../components/CreateOrUpdateActionItem";

export const AdminActionItemEdit = ({
	actionItem,
	defaultUnderwriterId,
}: {
	actionItem: ActionItem;
	defaultUnderwriterId: UserId;
}) => {
	const { setEditActionItem } = useActionItemsSelectionDispatch();

	return (
		<CreateOrUpdateActionItem
			onClose={() => setEditActionItem(undefined)}
			actionItemId={actionItem.id}
			relation={
				{
					relationId: actionItem.relationId,
					relationType: actionItem.relationType,
				} as Relations.ActionItems
			}
			inputDefaults={{
				title: actionItem.title,
				content: actionItem.content,
				dueAt: actionItem.dueAt,
				assigneeId: actionItem.assigneeId,
				isComplete: actionItem.status === "complete",
			}}
			defaultUnderwriterId={defaultUnderwriterId}
			isUpdate
		/>
	);
};
